import React from 'react';
import './CreateTask.css';

class CreateTask extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tasks: []
        }
    }
    submitTask() {
        var taskName = document.getElementById('task-name').value;
        var taskDescription = document.getElementById('task-description').value;
        var taskDate = document.getElementById('task-date').value;
        var taskLocation = document.getElementById('task-location').value;
        var taskTime = document.getElementById('task-time').value;
        var category = document.getElementById('task-category').value;
        var categories ={
            "Personal": "E5534B",
            "School": "CC6B2C",
            "Work": "46954A",
            "Other": "C96198",
            "None": "3A3D44"
        }
        var categoryColor = categories[category];
        var time = taskTime.split(':');
        if (time[0] > 12) {
            time[0] -= 12;
            taskTime = time[0] + ":" + time[1];
            taskTime += " PM";
        }else{
            taskTime += " AM";
        }
        var id = Math.floor(Math.random() * 1000000000);
        while (document.getElementById(id) != null) {
          id = Math.floor(Math.random() * 1000000000);
        }
        var task = {
            "name": taskName,
            "description": taskDescription,
            "date": taskDate,
            "time": taskTime,
            "location": taskLocation,
            "id": id,
            "category": category,
            "selected": false,
            "categoryColor": "#" + categoryColor,
        }
        var tasks = JSON.parse(localStorage.getItem('tasks'));
        if (tasks == null) {
            tasks = [];
        }
        tasks.push(task);
        localStorage.setItem('tasks', JSON.stringify(tasks));
        this.closePopup();
    }
    closePopup() {
        document.getElementById('opacity-layer').style.display = 'none';
        document.getElementById('create-task-popup').style.display = 'none';
        // reset color
        document.getElementById('select-category-color').style.backgroundColor = "#3A3D44";
        // reset form
        document.getElementById('task-category').value = "None";
        document.getElementById('task-name').value = "";
        document.getElementById('task-description').value = "";
        document.getElementById('task-date').value = "";
        document.getElementById('task-location').value = "";
        document.getElementById('task-time').value = "";
        

    }    
    updateCategory() {
        var category = document.getElementById('task-category').value;
        var categories ={
            "Personal": "E5534B",
            "School": "CC6B2C",
            "Work": "46954A",
            "Other": "C96198",
            "None": "3A3D44"
        }
        document.getElementById('select-category-color').style.backgroundColor = "#" + categories[category];
        this.setState({category: categories[category]})
    }

    render() {
        return (
            <div>
                <div id="opacity-layer" onClick={this.closePopup}></div>
                <div id="create-task-popup">
                    <form className='form-container'>
                        <h3 className='form-title'>Create Task</h3>
                        <div className="form-group">
                            <label htmlFor="task-name">Task Name</label>
                            <input type="text" className="form-control" id="task-name" placeholder="Enter task name" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="task-description">Task Description</label>
                            <textarea className="form-control" id="task-description" rows="3"></textarea>
                        </div>
                        <div className="form-group">
                            <label htmlFor="task-date">Task Date</label>
                            <input type="date" className="form-control" id="task-date" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="task-time">Task Time</label>
                            <input type="time" className="form-control" id="task-time" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="task-location">Task Location</label>
                            <input type="location" className="form-control" id="task-location" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="task-reminder">Task Category</label>
                            <div id="select-category">
                                <div id="select-category-color" style={{backgroundColor: "#" + this.state.category}}></div>
                                <select className="form-control" id="task-category" onChange={this.updateCategory} >
                                    <option value="None" >None</option>
                                    <option value="Work" >Work</option>
                                    <option value="Personal" >Personal</option>
                                    <option value="School" >School</option>
                                    <option value="Other" >Other</option>
                                </select>
                            </div>
                        </div>
                        <button type="submit" className="submit-task" onClick={this.submitTask}>✔️ Submit</button>
                        <button type="button" className="close-popup" onClick={this.closePopup}>🚫 Cancel</button>
                    </form>

                </div>
            </div>
        );
    }
}
export default CreateTask;